import {useCallback} from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../react-hooks/use-services.hook";
import {IGameContextViewModel} from "../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GameNavBarWrapperBox} from "./boxes/wrapper/game-nav-bar-wrapper.box";
import {FlexGrowItemBox} from "../../../themes/architecture/css-helpers/flex";
import {DepositGameNavBarMobileComponent} from "./game-nav-bar-items/deposit.game-nav-bar-item.mobile.component";
import {ExitGameNavBarMobileComponent} from "./game-nav-bar-items/exit.game-nav-bar-item.mobile.component";
import {AddFundsGameNavBarMobileComponent} from "./game-nav-bar-items/add-funds.game-nav-bar-item.mobile.component";
import {CyClass} from "../../../../common/cy-classes";
import {JackpotBarMagicBallComponent} from "../jackpot-bar-magic-ball/jackpot-bar-magic-ball.component";

export enum DisplayOn {
    Landscape,
    Portrait
}

interface IGameNavBarComponentProps {
    displayOn: DisplayOn;
    gameContext: IGameContextViewModel;
    // TODO: Refactor props shouldHideDepositButton and showAddFundsButton to a list of items
    shouldHideDepositButton: boolean;
    showAddFundsButton?: boolean;
}

/**
 * It renders only if isMobileOS and if enabled. Otherwise renders null.
 * It is a bar under the game (on portrait) or aside the game (on landscape) with shortcuts to deposit, exit game etc.
 */
export const GameNavBarMobileComponent: React.FC<IGameNavBarComponentProps> = observer((props) => {
    const services = useServices();

    const _captureElementRefPortrait = useCallback((element: HTMLDivElement) => {
        props.gameContext.gameParts.footerBarRenderer?.setGamePartElementRef(element);
    }, [props.gameContext]);

    const _captureElementRefLandscape = useCallback((element: HTMLDivElement) => {
        props.gameContext.gameParts.leftBarRenderer?.setGamePartElementRef(element);
    }, [props.gameContext]);

    if (!services.configuration.servicesConfigs.GameNavBar.enabled) {
        return null;
    }
    if (!services.device.os.isMobileOS) {
        return null;
    }
    if (services.jackpotBet.isEnabled && props.gameContext.gameInfo.hasJackpotBet) {        
        return null;
    }

    if (props.displayOn === DisplayOn.Portrait && !services.mediaQuery.portrait) {
        return null;
    }
    if (props.displayOn === DisplayOn.Landscape && !services.mediaQuery.landscape) {
        return null;
    }

    const _renderBarItems = () => {
        return <>
            {/* On landscape, the bar is vertical and on the left, the button must be on top */}
            {services.magic8ball.shouldRenderBall ? <div style={{padding: services.mediaQuery.landscape ? "0.8rem 0" : "0 0.8rem"}}>
                <JackpotBarMagicBallComponent verticalMode={services.mediaQuery.landscape} />
            </div> : null}
            <FlexGrowItemBox />
            {(!props.shouldHideDepositButton && !props.showAddFundsButton) && <DepositGameNavBarMobileComponent gameContext={props.gameContext} />}
            {props.showAddFundsButton && <AddFundsGameNavBarMobileComponent gameContext={props.gameContext} />}
            <ExitGameNavBarMobileComponent gameContext={props.gameContext} />
        </>;
    }

    if (props.displayOn === DisplayOn.Portrait && services.mediaQuery.portrait) {
        return <GameNavBarWrapperBox ref={_captureElementRefPortrait} className={CyClass('cy-game-navbar-mobile')}>
            {_renderBarItems()}
        </GameNavBarWrapperBox>
    }
    if (props.displayOn === DisplayOn.Landscape && services.mediaQuery.landscape) {
        return <GameNavBarWrapperBox ref={_captureElementRefLandscape} className={CyClass('cy-game-navbar-mobile')}>
            {_renderBarItems()}
        </GameNavBarWrapperBox>
    }
    return null;
});